export default {
  compilation: null,
  compilationLoading: false,
  updateCompilationLoading: false,
  updateStoryLoading: false,

  compilationsList: null,
  compilationsListLoading: null,

  storiesList: null,
  storiesLoading: null,
  storiesMeta: null,
  storiesOptions: null,

  story: null,
  storyLoading: false,
  storyCreateLoading: false,
  storyCreateInitData: null,
  storyPinLoading: false,
};
